import type { CSSProperties } from 'react';
import type { Color } from '../../../types/color';
import type { RouteItem } from '../../routes';

export interface PageConfigContext {
  (params: PageConfig): void;
}

export interface PageConfigCompContext {
  getPageConfig?: () => PageConfig;
  updatePageConfig?: (params: PageConfig) => void;
}

interface TitleFuncType {
  (): boolean | void;
}

// 按钮类型
export enum BackBtnType {
  Back = 1,
  Close = 2,
  Finish = 3,
  AddIcon = 4,
  Question = 5,
  CustomerService = 6,
  Add = 7,
}

export enum HeaderFontStyle {
  Light = '#fff',
  Dark = '#361851',
  Theme = '#00c34e',
}

export type whatsAppConfig = React.ImgHTMLAttributes<HTMLImageElement>;

export enum ForceDisplay {
  ForceShow = 1,
  ForceHide = 2,
}

export interface PageConfig {
  leftFunc?: TitleFuncType | null; // 左边按钮的触发方法
  rightFunc?: TitleFuncType | null; // 右边按钮的触发方法
  title?: string | null | JSX.Element; // 标题栏
  leftBtnType?: BackBtnType | null; // 左侧按钮的样式
  rightBtnType?: BackBtnType | null | string; // 右侧按钮的样式
  layoutStyle?: CSSProperties; // 整体layout的样式
  contentLayoutStyle?: CSSProperties; // contentLayout的样式
  headerStyle?: CSSProperties; // header样式
  hideHeader?: boolean; // 隐藏导航栏
  outerLayoutClassName?: string; // 外部布局的类名
  layoutClassName?: string; // 布局的类名---下面的布局样式
  headerClassName?: string; // 导航栏类名
  headerFontStyle?: HeaderFontStyle | Color; // 导航栏颜色和icon的颜色
  rightFontStyle?: HeaderFontStyle | Color | null; // 右侧按钮和icon颜色
  hideTitle?: boolean; // 隐藏标题
  whatsApp?: whatsAppConfig | boolean;
  pageHideTopPadding?: boolean;
  titleClassName?: string; // 标题样式
  rightBtnClassName?: string; // 右侧按钮样式
  headerForceDisplay?: ForceDisplay; // 顶部导航栏是否强制显示或者强制隐藏，优先级最高
}

export interface LayoutPropsType {
  children: React.ReactNode;
  routes: RouteItem[];
  modulePath: string;
  moduleHideHeader?: boolean;
  moduleHideTopPadding?: boolean;
  moduleHideWhatsApp?: boolean;
}
